var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tci-recruit',{attrs:{"subtitle":"PROJECT MANAGER","title":_vm.$t('recruit.mainPage.recruit_sap'),"recruits":_vm.infos}})
}
var staticRenderFns = []

export { render, staticRenderFns }